/* eslint-disable @next/next/no-img-element */
import Hero from "public/marketing/glow.png"

export const ColorBlur = ({
  show = true,
  size = "base",
  opacity = 0.2,
  fixed = false,
}: {
  show?: boolean
  size?: "xl" | "base"
  opacity?: number
  fixed?: boolean
}) => {
  return (
    <div
      className="transform-gpu"
      style={{
        display: "flex",
        pointerEvents: "none",
        userSelect: "none",
        justifyContent: "center",
        alignItems: "center",
        transition: "all 2s ease",
        position: fixed ? "fixed" : "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: show ? opacity : opacity * 1.5,
        transform: show ? "scale(1) rotateZ(0)" : "scale(1.25) rotateZ(-10deg)",
        transformOrigin: "center",
      }}
    >
      <img
        style={{
          transform: size == "xl" ? "scale(1.75)" : "scale(1.0)",
          minWidth: "100vw",
          minHeight: "700px",
          height: "auto",
        }}
        src={Hero.src}
        alt="gradient blur "
        className="object-cover"
      ></img>
    </div>
  )
}
